// list of all tracker events
export type MixPanelEventsType = typeof events;

const events = {
  pwaInstallPrompted: 'pwaInstallPrompted',
  pwaInstallResponse: 'pwaInstallResponse',
  pwaInstallAccountWidget: 'pwaInstallAccountWidget',
  pwaInstallBrowserResponse: 'pwaInstallBrowserResponse',
  pwaPushNotificationsPrompted: 'pwaPushNotificationsPrompted',
  pwaPushNotificationsResponse: 'pwaPushNotificationsResponse',
  pwaPushNotificationsBrowserResponse: 'pwaPushNotificationsBrowserResponse',

  accountListArrow: 'accountListArrow',
  active: 'active',
  appearance: 'appearance',
  crash: 'crash',
  exception: 'exception',
  assert: 'assert',
  fiLoginFixItFlowStart: 'fiLoginFixItFlowStart',
  fiMigrationPrompt: 'fiMigrationPrompt',
  fiMigrationEligibility: 'fiMigrationEligibility',
  fiMigrationSaveSuccess: 'fiMigrationSaveSuccess',
  fiLoginNameSave: 'fiLoginNameSave',
  txnManualMatch: 'txnManualMatch',
  txnColumnsSettings: 'txnColumnsSettings',
  txnColumnsMove: 'txnColumnsMove',
  txnColumnsSort: 'txnColumnsSort',
  txnColumnsFilter: 'txnColumnsFilter',
  quickFilter: 'quickFilter',
  toolbarMenuItem: 'toolbarMenuItem',
  toolbarSelectionButton: 'toolbarSelectionButton',
  toolbarAddInvoice: 'toolbarAddInvoice',
  toolbarAddEstimate: 'toolbarAddEstimate',
  toolbarAddSalesReceipt: 'toolbarAddSalesReceipt',
  toolbarAddCreditMemo: 'toolbarAddCreditMemo',
  txnRegisterSearchOpened: 'txnRegisterSearchOpened',
  txnRegisterDateOpened: 'txnRegisterDateOpened',
  txnRegisterFilterOpened: 'txnRegisterFilterOpened',
  txnRegisterBulkSelect: 'txnRegisterBulkSelect',
  txnRegisterBulkEdit: 'txnRegisterBulkEdit',
  txnRegisterBulkMerge: 'txnRegisterBulkMerge',
  txnRegisterExport: 'txnRegisterExport',
  txnRegisterImport: 'txnRegisterImport',
  txnDelete: 'txnDelete',
  txnOpen: 'txnOpen',
  txnSave: 'txnSave',
  txnPrefs: 'txnPrefs',
  txnRegActivity: 'txnRegActivity',
  txnReviewMany: 'txnReviewMany',
  txnSkip: 'txnSkip',
  txnReviewBanner: 'txnReviewBanner',
  // account menu
  viewAccountMenu: 'viewAccountMenu',
  changeAccountSetting: 'changeAccountSetting',
  deleteAccount: 'deleteAccount',

  spendingChartView: 'spendingChartView',
  spendingPlanClientCalc: 'spendingPlanClientCalc',

  barSelected: 'barSelected',

  connectivity: 'connectivity',
  experiment: 'experiment',

  navMenuClick: 'navMenuClick',
  myAccount: 'myAccount',
  datasetChange: 'datasetChange',

  addFIStart: 'addFIStart',
  addFISelect: 'addFISelect',
  addFISelectContinue: 'addFISelectContinue',
  fiSignUpScreen: 'fiSignUpScreen',
  fiSignUpSignUp: 'fiSignUpSignUp',
  addFIAuthenticated: 'addFIAuthenticated',
  addFIOAuth: 'addFIOAuth',
  addFIComplete: 'addFIComplete',
  viewSecurityMsg: 'viewSecurityMsg',

  addFICancel: 'addFICancel',
  addFIError: 'addFIError',

  fixFIStart: 'fixFIStart',
  fixFISelect: 'fixFISelect',
  fixFIAuthenticated: 'fixFIAuthenticated',
  fixFIOAuth: 'fixFIOAuth',
  fixFIComplete: 'fixFIComplete',

  fixFICancel: 'fixFICancel',
  fixFIError: 'fixFIError',

  refreshStart: 'refreshStart',
  refreshPoll: 'refreshPoll',
  refreshSuccess: 'refreshSuccess',
  refreshError: 'refreshError',
  refreshDelay: 'refreshDelay',
  refreshEnd: 'refreshEnd',

  watchlistCreate: 'watchlistCreate',
  watchlistEdit: 'watchlistEdit',
  watchlistExtend: 'watchlistExtend',
  watchlistDelete: 'watchlistDelete',

  nps: 'nps',
  npsStart: 'npsStart',
  npsRequested: 'npsRequested',

  categoryCreate: 'categoryCreate',
  categoryEdit: 'categoryEdit',
  categoryDelete: 'categoryDelete',

  tagCreate: 'tagCreate',
  tagEdit: 'tagEdit',

  // getting started funnels and flows
  pageView: 'pageView',
  signIn: 'signIn',
  logout: 'logout', // props: description, context

  // simplifi set-up flow
  datasetCreated: 'datasetCreated',
  firstName: 'firstName',
  lastName: 'lastName',
  zipCode: 'zipCode',
  addedNewIncome: 'addedNewIncome',
  addedNewBill: 'addedNewBill',
  confirmedIncome: 'confirmedIncome',
  confirmedBill: 'confirmedBills',
  removedIncome: 'removedIncome',
  removedBill: 'removedBill',
  editModel: 'editModel',
  editModelGSF: 'editModelGSF',
  fisAdded: 'fisAdded',
  completeGettingStarted: 'completeGettingStarted',

  showIntercom: 'showIntercom',

  survey: 'survey', // TODO: temporary hack - we should use MCP instead - remove it

  // Saving Goals
  createGoal: 'createGoal',
  editGoal: 'editGoal',
  takeFrom: 'takeFrom',
  addTo: 'addTo',

  // app init
  init: 'init',
  load: 'load',
  persistLoadStart: 'persistLoadStart',
  persistLoadComplete: 'persistLoadComplete',
  persistLoadError: 'persistLoadError',
  // A single slice failed to decrypt/parse and reset to defaults; the rest of the store rehydrated.
  persistSliceResetOnLoad: 'persistSliceResetOnLoad',
  persistPurge: 'persistPurge',

  // app intro
  viewIntroAppScreen: 'viewIntroAppScreen',

  // Monthly Summary Rating
  monthlySummary: 'monthlySummary', // { rating: int, feedback: string }

  serviceWorker: 'serviceWorker',
  csvImport: 'csvImport',

  budgetItemCreate: 'budgetItemCreate',
  budgetItemEdit: 'budgetItemEdit',
  budgetItemDelete: 'budgetItemDelete',
  budgetItemReleaseFunds: 'budgetItemReleaseFunds',
  budgetItemDetailsView: 'budgetItemDetailsView',

  webSocket: 'webSocket',

  // Rules
  txnRulesList: 'txnRulesList',
  txnRuleStarted: 'txnRuleStarted',
  txnRuleCompleted: 'txnRuleCompleted',
  txnRuleDuplicate: 'txnRuleDuplicate',
  txnRuleSearch: 'txnRuleSearch',
  txnRuleDeleted: 'txnRuleDeleted',
  txnRulePreviewShown: 'txnRulePreviewShown',
  txnRuleRevised: 'txnRuleRevised',

  refundCreate: 'refundCreate',
  refundEdit: 'refundEdit',
  refundManualMatch: 'refundManualMatch',
  refundDelete: 'refundDelete',
  refundUnMatch: 'refundUnMatch',

  subscriptionAlertShown: 'subscriptionAlertShown',
  subscriptionAlertCTA: 'subscriptionAlertCTA',
  subscriptionAlertDismissed: 'subscriptionAlertDismissed',

  browserUpdate: 'browserUpdate',

  // billGo events
  addBillerStart: 'addBillerStart',
  addBillerCancel: 'addBillerCancel',

  fixBillerStart: 'fixBillerStart',
  disconnectBiller: 'disconnectBiller',

  // fiServ events
  addBillStart: 'addBillStart',
  billerSearch: 'billerSearch',
  billerSelect: 'billerSelect',
  enterDetails: 'enterDetails',
  fiservBillPending: 'fiservBillPending',
  fiservBillSuccess: 'fiservBillSuccess',
  fiservBillFailed: 'fiservBillFailed',
  fiservBillStatusChange: 'fiservBillStatusChange',
  launchQuicken: 'launchQuicken',

  // PWA Subscription tracking
  pickPlan: 'pickPlan',
  subscriptionPurchaseError: 'subscriptionPurchaseError',
  startTrial: 'startTrial',

  // Setup Checklist
  checklistView: 'checklistView',
  checklistStart: 'checklistStart',
  checklistClick: 'checklistClick',
  checklistItemComplete: 'checklistItemComplete',
  checklistComplete: 'checklistComplete',
  checklistDismiss: 'checklistDismiss',

  // Request FI
  requestFISelected: 'requestFISelected',
  requestFISubmit: 'requestFISubmit',

  feedback: 'feedback',
  authWidget: 'authWidget',

  // achievements
  achievementsPageView: 'achievementsPageView',
  achievementStart: 'achievementStart',
  milestonesEarned: 'milestonesEarned',
  achievementComplete: 'achievementComplete',

  // Lifehub
  qlhGetStartedClicked: 'qlhGetStartedClicked',
  qlhBannerDismissed: 'qlhBannerDismissed',
  qlhLaunchClicked: 'qlhLaunchClicked',

  // A2A
  viewTransfersIntroScreen: 'viewTransfersIntroScreen',

  // User Onboarding
  viewIdentityVerification: 'viewIdentityVerification',
  identitySelectDisclosure: 'identitySelectDisclosure',
  identityFormCancel: 'identityFormCancel',
  identityFormSubmitted: 'identityFormSubmitted',
  identityVerificationResult: 'identityVerificationResult',
  identityVerificationCompleted: 'identityVerificationCompleted',
  identityUnableToComplete: 'identityUnableToComplete',
  identityVerificationError: 'identityVerificationError',
  identityVerificationSubmitted: 'identityVerificationSubmitted',

  // Email Verification
  viewEmailVerification: 'viewEmailVerification',
  verificationEmailSent: 'verificationEmailSent',
  verificationEmailResent: 'verificationEmailResent',
  emailVerified: 'emailVerified',

  // Phone Verification
  viewPhoneVerification: 'viewPhoneVerification',
  verificationPhoneSent: 'verificationPhoneSent',
  verificationPhoneResent: 'verificationPhoneResent',
  phoneVerified: 'phoneVerified',

  // Account verification
  viewAccountSetup: 'viewAccountSetup',
  institutionSelect: 'institutionSelect',
  accountSelect: 'accountSelect',
  enterAccountDetails: 'enterAccountDetails',
  routingNumber: 'routingNumber',
  accountNumber: 'accountNumber',
  accountSetupCompleted: 'accountSetupCompleted',
  authorizeTransfer: 'authorizeTransfer',
  viewMicrodeposits: 'viewMicrodeposits',
  accountSetupError: 'accountSetupError',

  // Microdeposit verification (Only used as a backup so as long as the intuit widget holds up we should never get these)
  microdepositSubmit: 'microdepositSubmit',

  // Transfers
  transferStart: 'transferStart',
  transferSubmit: 'transferSubmit',
  transfersError: 'transferError',

  // Transfer Activity Tracking
  viewTransferActivity: 'viewTransferActivity',
  cancelTransfer: 'cancelTransfer',

  //  Investments
  investmentsView: 'investmentsView',
  timeSpentOnInvestments: 'timeSpentOnInvestments',
  holdingDetailView: 'holdingDetailView',
  investmentNewsStoryView: 'investmentNewsStoryView',
  investmentsColumnChange: 'investmentsColumnChange',
  changeHolding: 'changeHolding',
  investmentsChartScaleType: 'investmentsChartScaleType',
  investmentsChartType: 'investmentsChartType',

  connection: 'connection', // track online/offline status

  // Net Worth
  viewNetWorthV2: 'viewNetWorthV2',
  dateFilterSelect: 'dateFilterSelect',
  accountExclusion: 'accountExclusion',
  chartViewSelect: 'chartViewSelect',
  yAxisSetting: 'yAxisSetting',
  breakdownCardSelect: 'breakdownCardSelect',
  hideCents: 'hideCents',

  // Spending plan
  hideIgnoredTxns: 'hideIgnoredTxns',
  viewSPv1Onboarding: 'viewSPv1Onboarding',
  viewSpendingPlan: 'viewSpendingPlan',
  viewIncomeAfterBills: 'viewIncomeAfterBills',
  viewPlannedSpending: 'viewPlannedSpending',
  viewOtherSpending: 'viewOtherSpending',
  updatePlannedSpendingItemView: 'updatePlannedSpendingItemView',
  rolloversOptIn: 'rolloversOptIn',
  startingRollover: 'startingRollover',
  viewSpendingPlanFutureMonths: 'viewSpendingPlanFutureMonths',
  viewProjectedOtherSpending: 'viewProjectedOtherSpending',
  viewFixItBanner: 'viewFixItBanner',
  dismissFixIt: 'dismissFixIt',
  spendingPlanClosed: 'spendingPlanClosed',
  resolvedSpendingPlan: 'resolvedSpendingPlan',
  editSpendingPlanBucket: 'editSpendingPlanBucket',
  txnUpdatedInFTSRegister: 'txnUpdatedInFTSRegister',
  goalUpdatedInFTSRegister: 'goalUpdatedInFTSRegister',
  spendingPlanSetupCompleted: 'spendingPlanSetupCompleted',
  spendingPlanBillSort: 'spendingPlanBillSort',
  spendingPlanMonthViewed: 'spendingPlanMonthViewed',
  spendingPlanMonthViewedDuration: 'spendingPlanMonthViewedDuration',

  // Spending Plan GSF V2
  viewSpendingPlanOnboardingV2: 'viewSpendingPlanOnboardingV2',
  completeSpendingPlanIntro: 'completeSpendingPlanIntro',
  startSPIncomeVerification: 'startSPIncomeVerification',
  verifiedOneTimeIncome: 'verifiedOneTimeIncome',
  completeSPIncomeVerification: 'completeSPIncomeVerification',
  automaticallyIncludeIncome: 'automaticallyIncludeIncome',
  startSPBillsVerification: 'startSPBillsVerification',
  completeSPBillsVerification: 'completeSPBillsVerification',
  viewPlannedSpendIntro: 'viewPlannedSpendIntro',
  selectSuggestedBudget: 'selectSuggestedBudget',
  deleteSuggestedBudget: 'deleteSuggestedBudget',
  addSuggestedBudget: 'addSuggestedBudget',
  addBudgetFromOtherSpend: 'addBudgetFromOtherSpend',
  viewOtherSpendIntro: 'viewOtherSpendIntro',
  completeSpendingPlanSetup: 'completeSpendingPlanSetup',
  viewSavingsGoalSetupBanner: 'viewSavingsGoalSetupBanner',
  viewSpendingPlanTooltips: 'viewSpendingPlanTooltips',
  viewTransfersLearnMore: 'viewTransfersLearnMore',

  // autoRelease
  enableAutoRelease: 'enableAutoRelease',
  disableAutoRelease: 'disableAutoRelease',
  batchReleaseFunds: 'batchReleaseFunds',

  // Add Asset: Zillow
  addAssetsUX_1: 'addAssetsUX_1',
  zillowUX_2: 'zillowUX_2',
  zillowUX_3: 'zillowUX_3',
  zillowUX_4: 'zillowUX_4',
  zillowUX_5: 'zillowUX_5',
  updateHomeValue: 'updateHomeValue',

  // Add Asset: Kelley Blue Book
  kbbFlowBegin: 'kbbFlowBegin',
  kbbCondition: 'kbbCondition',
  kbbReviewValue: 'kbbReviewValue',
  kbbFetchSucceeded: 'kbbFetchSucceeded',
  kbbFetchFailed: 'kbbFetchFailed',
  kbbAddKbbVehicle: 'kbbAddKbbVehicle',
  kbbAddManual: 'kbbAddManual',
  kbbStepManual: 'kbbStepManual',
  kbbFinish: 'kbbFinish',
  kbbEditFieldsChanged: 'kbbEditFieldsChanged',
  kbbEditOnly: 'kbbEditOnly',
  kbbAccountRepairIds: 'kbbAccountRepairIds',

  // Dataset sharing
  viewSpaces: 'viewSpaces',
  inviteMember: 'inviteMember',
  sharedDatasetAccessed: 'sharedDatasetAccessed',

  addCustomSecurity: 'addCustomSecurity',
  securityPolicyViolation: 'securityPolicyViolation',

  // Custom Freq
  viewFrequencyDetails: 'viewFrequencyDetails',

  // Upcoming
  viewUpcoming: 'viewUpcoming',
  viewCashFlow: 'viewCashFlow',
  viewRefundTracker: 'viewRefundTracker',
  saveDatePreference: 'saveDatePreference',
  viewPastDue: 'viewPastDue',
  sortApplied: 'sortApplied',
  viewRecurring: 'viewRecurring',
  seriesTabClick: 'seriesTabClick',

  //Launch Darkly Failure
  launchDarkly: 'launchDarkly',

  // QEM events
  qemGsfWelcome: 'qemGsfWelcome',
  qemGsfHouseholdName: 'qemGsfHouseholdName',
  qemGsfComplete: 'qemGsfComplete',

  qemGuideConnectQuicken: 'qemGuideConnectQuicken',
  qemGuideDismiss: 'qemGuideDismiss',

  qemFolderAddItem: 'qemFolderAddItem',
  qemFolderAddItemSelected: 'qemFolderAddItemSelected',
  qemFolderRemoveItemSelected: 'qemFolderRemoveItemSelected',
  qemFolderAdditemDismissed: 'qemFolderAdditemDismissed',

  qemImageUpload: 'qemImageUpload',
  qemAddItem: 'qemAddItem',

  // QEM - Quicken Integration
  qemCon2PfmStartImport: 'qemCon2PfmStartImport',
  qemCon2PfmDataFile: 'qemCon2PfmDataFile',
  qemCon2PfmAccounts: 'qemCon2PfmAccounts',
  qemCon2PfmProperty: 'qemCon2PfmProperty',
  qemCon2PfmBills: 'qemCon2PfmBills',
  qemCon2PfmComplete: 'qemCon2PfmComplete',
  qemPfmDisconnectDataFile: 'qemPfmDisconnectDataFile',
  qemPfmDisconnectAcct: 'qemPfmDisconnectAcct',
  qemPfmDisconnectTransaction: 'qemPfmDisconnectTransaction',
  qemPfmConnectAcct: 'qemPfmConnectAcct',
  qemPfmConnTransaction: 'qemPfmConnTransaction',

  // Transactions On Demand
  transactionsOnDemand: 'transactionsOnDemand',

  // Splits V2
  viewSplitsV2: 'viewSplitsV2',
  splitsV2Action: 'splitsV2Action',
  saveSplitsV2: 'saveSplitsV2',
  splitsV2ShowMore: 'splitsV2ShowMore',
  selectSplitsAlways: 'selectSplitsAlways',

  // Credit Score
  creditScoreEntry: 'creditScoreEntry',
  creditScoreReg: 'creditScoreReg',
  creditScoreReport: 'creditScoreReport',
  creditScoreExpectedReportMissing: 'creditScoreExpectedReportMissing',
  creditScoreStaleProfileCleanup: 'creditScoreStaleProfileCleanup',

  // Scheduled Transactions
  createSeries: 'createSeries',
  editSeries: 'editSeries',
  changeSeries: 'changeSeries',
  deleteReminder: 'deleteReminder',
  linkReminderToTxn: 'linkReminderToTxn',
  excludeFromSpendingPlan: 'excludeFromSpendingPlan',
  excludeFromReports: 'excludeFromReports',
  changeReminder: 'changeReminder',
  reminderExcludeFromSpendingPlan: 'reminderExcludeFromSpendingPlan',
  reminderExcludeFromReports: 'reminderExcludeFromReports',

  // Fi Issue Banner
  fiStatusBanner: 'fiStatusBanner',

  // Net Income - Reports
  viewedReports: 'viewedReports',
  expandedCategory: 'expandedCategory',
  collapsedCategory: 'collapsedCategory',
  drilledIntoCategory: 'drilledIntoCategory',
  exportReport: 'exportReport',
  changeGridDisplayOption: 'changeGridDisplayOption',

  // Report Filters
  filteredUsageType: 'filteredUsageType',
  filterViewBy: 'filterViewBy',
  filterIntervals: 'filterIntervals',
  filterBreakdownBy: 'filterBreakdownBy',
  filterSet: 'filterSet',
  reportSetDateRange: 'reportSetDateRange',
  reportReset: 'reportReset',
  reportSetColumn: 'reportSetColumn',
  reportSetRow: 'reportSetRow',
  reportSetType: 'reportSetType',
  reportSetMileage: 'reportSetMileage',
  reportSaved: 'reportSaved',
  reportDeleted: 'reportDeleted',
  reportClosed: 'reportClosed',
  reportRenamed: 'reportRenamed',
  reportOpened: 'reportOpened',
  reportChartToggled: 'reportChartToggled',
  reportDrillDownBack: 'reportDrillDownBack',
  reportExpandCollapseAll: 'reportExpandCollapseAll',
  reportResetDisplayDefaults: 'reportResetDisplayDefaults',
  reportSearchOpened: 'reportSearchOpened',
  reportSearchResultSelected: 'reportSearchResultSelected',
  reportChartWindowed: 'reportChartWindowed',
  reportSavedDrawerOpened: 'reportSavedDrawerOpened',
  reportComparisonApplied: 'reportComparisonApplied',
  reportComparisonCleared: 'reportComparisonCleared',

  changeChartType: 'changeChartType',
  // Retirement Planner
  viewRetirementPlanner: 'viewRetirementPlanner',
  editRetirementPlanner: 'editRetirementPlanner',
  resetToDefault: 'resetToDefault',
  retirementBannerDismiss: 'retirementBannerDismiss',

  barchartPeriod: 'barchartPeriod',

  // Privacy Mode
  privacyMode: 'privacyMode',

  // QBP
  createInvoiceStart: 'createInvoiceStart',
  createInvoiceSaved: 'createInvoiceSaved',
  editInvoiceSaved: 'editInvoiceSaved',
  previewInvoice: 'previewInvoice',
  sendInvoiceStart: 'sendInvoiceStart',
  sendInvoiceFinished: 'sendInvoiceFinished',
  shareInvoiceStart: 'shareInvoiceStart',
  shareInvoiceFinished: 'shareInvoiceFinished',
  viewInvoiceDashboard: 'viewInvoiceDashboard',
  editClient: 'editClient',
  addGlobalItemStart: 'addGlobalItemStart',
  addGlobalItem: 'addGlobalItem',
  editGlobalItem: 'editGlobalItem',
  archiveGlobalItem: 'archiveGlobalItem',
  unarchiveGlobalItem: 'unarchiveGlobalItem',

  // Products & Services Import
  importItemsStart: 'importItemsStart',
  importItemsTemplateDownload: 'importItemsTemplateDownload',
  importItemsFileUploaded: 'importItemsFileUploaded',
  importItemsFileError: 'importItemsFileError',
  importItemsMapped: 'importItemsMapped',
  importItemsSubmitted: 'importItemsSubmitted',
  importItemsComplete: 'importItemsComplete',
  importItemsAbandoned: 'importItemsAbandoned',

  createProjectStart: 'createProjectStart',
  editProject: 'editProject',
  createProjectSaved: 'createProjectSaved',
  projectCompleted: 'projectCompleted',
  projectAddProductService: 'projectAddProductService',
  projectEditProductService: 'projectEditProductService',
  projectAddExpense: 'projectAddExpense',
  viewProjectDetails: 'viewProjectDetails',
  projectReopened: 'projectReopened',
  projectDeleted: 'projectDeleted',
  switchedProjectsTab: 'switchedProjectsTab',
  createClientStart: 'createClientStart',
  createClientSaved: 'createClientSaved',
  viewedClientDashboard: 'viewedClientDashboard',
  viewedClientDetails: 'viewedClientDetails',
  sortedClientList: 'sortedClientList',
  searchedClientList: 'searchedClientList',
  clientArchived: 'clientArchived',
  clientUnarchived: 'clientUnarchived',
  printReport: 'printReport',
  addBusinessStart: 'addBusinessStart',
  addBusinessSaved: 'addBusinessSaved',
  addBusinessSkipped: 'addBusinessSkipped',
  addBusinessComplete: 'addBusinessComplete',
  updatedTaxGroup: 'updatedTaxGroup',

  // GSF QBP
  greetingQBP: 'greetingQBP',
  nameZipQBP: 'nameZipQBP',
  businessGoalsQBP: 'businessGoalsQBP',
  businessEntryQBP: 'businessEntryQBP',
  FILauncherQBP: 'FILauncherQBP',
  selectedFIQBP: 'selectedFIQBP',
  connectedFIQBP: 'connectedFIQBP',
  fiConnectLaterQBP: 'fiConnectLaterQBP',
  fiFinishLaterQBP: 'fiFinishLaterQBP',
  fiConnectRemainingQBP: 'fiConnectRemainingQBP',
  fiConnectLaterDismissQBP: 'fiConnectLaterDismissQBP',
  billScoutWaiterQBP: 'billScoutWaiterQBP',
  incomeQBP: 'incomeQBP',
  billsQBP: 'billsQBP',
  finalRedirectQBP: 'finalRedirectQBP',

  // QBP : Stripe enable flow events
  enableStripeLearnMore: 'enableStripeLearnMore',
  stripeConnectFlowStart: 'stripeConnectFlowStart',
  stripeConnectFlowComplete: 'stripeConnectFlowComplete',

  // QBP : Payment events
  stripeInvoicePayment: 'stripeInvoicePayment', // paying an invoice through Stripe
  failedInvoicePayment: 'failedInvoicePayment', // failed payment through Stripe
  invoicePayment: 'invoicePayment', // Non Stripe invoice payments
  creditGenerated: 'creditGenerated', // For Overpayment

  // QBP: Account Bar Reorder
  reorderAccountGroups: 'reorderAccountGroups',
  shownAccountGroupInsert: 'shownAccountGroupInsert',
  dismissedAccountGroupInsert: 'dismissedAccountGroupInsert',

  // QBP: Mileage Tracker
  createMileageStart: 'createMileageStart',
  createMileageSaved: 'createMileageSaved',
  editMileageSaved: 'editMileageSaved',
  openedMileage3DotMenu: 'openedMileage3DotMenu',
  // GSF
  greeting: 'greeting',
  nameZip: 'nameZip',
  FILauncher: 'FILauncher',
  billScoutWaiter: 'billScoutWaiter',
  income: 'income',
  bills: 'bills',
  finalRedirect: 'finalRedirect',

  billScout: 'billScout',
  logoTicker: 'logoTicker',
  txnSwipeAction: 'txnSwipeAction',

  // Ai summarize
  AIWhyClick: 'AIWhyClick',
  AIWhyClose: 'AIWhyClose',
  AIWhyThumbsUp: 'AIWhyThumbsUp',
  AIWhyThumbsDown: 'AIWhyThumbsDown',
  AIWhyThumbsUpReason: 'AIWhyThumbsUpReason',
  AIWhyThumbsDownReason: 'AIWhyThumbsDownReason',

  AISumThumbsUp: 'AISumThumbsUp',
  AISumThumbsUpReasons: 'AISumThumbsUpReasons',
  AISumThumbsUpExplanation: 'AISumThumbsUpExplanation',
  AISumThumbsDown: 'AISumThumbsDown',
  AISumThumbsDownReasons: 'AISumThumbsDownReasons',
  AISumThumbsDownExplanation: 'AISumThumbsDownExplanation',

  AIChartCreate: 'AIChartCreate',
  AIChatGoalCreate: 'AIChatGoalCreate',
  AIChatBulkEditCategoriesPayees: 'AIChatBulkEditCategoriesPayees',
  AIChatTxnSearch: 'AIChatTxnSearch',
  AIChatInvestInfo: 'AIChatInvestInfo',
  AIChatRecurring: 'AIChatRecurring',
  AIChatListBills: 'AIChatListBills',
  modal: 'modal',

  AIChatHomeQuestion: 'AIChatHomeQuestion',
  AIContextualPromptChipClick: 'AIContextualPromptChipClick',
  AIContextualPromptChipAskSomethingElse: 'AIContextualPromptChipAskSomethingElse',
  AIContextualPromptChipSuggestMore: 'AIContextualPromptChipSuggestMore',
  AIOverviewCardSummarizeClick: 'AIOverviewCardSummarizeClick',
  AIOn: 'AIOn',
  AIOff: 'AIOff',
  AIContextualPromptChipsOn: 'AIContextualPromptChipsOn',
  AIContextualPromptChipsOff: 'AIContextualPromptChipsOff',
  AIWeeklyReportOn: 'AIWeeklyReportOn',
  AIWeeklyReportOff: 'AIWeeklyReportOff',
  AIChatSend: 'AIChatSend',
  AISuggest: 'AISuggest',

  // Tax Planner
  viewTaxPlanner: 'viewTaxPlanner',
  viewTaxPlannerBusiness: 'viewTaxPlannerBusiness',
  viewTaxPlannerDetails: 'viewTaxPlannerDetails',
  taxPlannerQuarterlySummary: 'taxPlannerQuarterlySummary',
  editTaxPlannerBusiness: 'editTaxPlannerBusiness',
  editTaxPlannerDetailsFilingStatus: 'editTaxPlannerDetailsFilingStatus',
  editTaxPlannerDetailsW2Income: 'editTaxPlannerDetailsW2Income',
  editTaxPlannerDetailsHaveW2Income: 'editTaxPlannerDetailsHaveW2Income',
  editTaxPlannerDetailsDeductions: 'editTaxPlannerDetailsDeductions',
  editTaxPlannerDetailsAdditionalDeductions: 'editTaxPlannerDetailsAdditionalDeductions',
  editTaxPlannerDetailsExpandInvestments: 'editTaxPlannerDetailsExpandInvestments',
  editTaxPlannerDetailInvestments: 'editTaxPlannerDetailInvestments',
  transactionMenu: 'transactionMenu',
  recurringMenu: 'recurringMenu',
  taxPlannerOnboardingStart: 'taxPlannerOnboardingStart',
  taxPlannerOnboardingIntro_1: 'taxPlannerOnboardingIntro_1',
  taxPlannerOnboardingDetails_2: 'taxPlannerOnboardingDetails_2',
  taxPlannerOnboardingTracking_3: 'taxPlannerOnboardingTracking_3',
  taxPlannerOnboardingTracking_4: 'taxPlannerOnboardingTracking_4',

  manualAccountBalanceRefresh: 'manualAccountBalanceRefresh',
  performanceWarning: 'performanceWarning',

  // User Guide
  userGuideOpen: 'userGuideOpen',
  userGuideClose: 'userGuideClose',
  userGuideDrag: 'userGuideDrag',

  alertRules: 'alertRules',

  // Dashboard business cards
  businessCardView: 'businessCardView',
  businessCardClick: 'businessCardClick',
  businessCardCtaClick: 'businessCardCtaClick',
  businessCardSortChange: 'businessCardSortChange',
  businessCardScrollExpand: 'businessCardScrollExpand',

  // Service-driven dashboard tasks
  taskCardView: 'taskCardView',
  taskDrawerOpen: 'taskDrawerOpen',
  taskDrawerFilterChange: 'taskDrawerFilterChange',
  taskView: 'taskView',
  taskActionClick: 'taskActionClick',
  taskDismissClick: 'taskDismissClick',
  taskRestoreClick: 'taskRestoreClick',

  // Dashboard quick actions experiment
  dashboardQuickActionsOpened: 'dashboardQuickActionsOpened',
  dashboardQuickActionsClosed: 'dashboardQuickActionsClosed',
  dashboardQuickActionsSelected: 'dashboardQuickActionsSelected',

  // Spending Dashboard
  viewSpendingDashboard: 'viewSpendingDashboard',
  defaultDateChanged: 'defaultDateChanged',
  spendingBarSelected: 'spendingBarSelected',
  accountFilterChanged: 'accountFilterChanged',
  watchlistButtonSelected: 'watchlistButtonSelected',
  completeWatchlistCreate: 'completeWatchlistCreate',

  // Receipt Center
  receiptCenterOpen: 'receiptCenterOpen',
  receiptTransactionUploadStart: 'receiptTransactionUploadStart',
  receiptCaptureStart: 'receiptCaptureStart',
  receiptCaptureCancelled: 'receiptCaptureCancelled',
  receiptUploadStaged: 'receiptUploadStaged',
  receiptUploadCancelled: 'receiptUploadCancelled',
  receiptUploadConfirmed: 'receiptUploadConfirmed',
  receiptUploadSubmitted: 'receiptUploadSubmitted',
  receiptListView: 'receiptListView',
  receiptProcessingResult: 'receiptProcessingResult',
  receiptTransactionLinkResult: 'receiptTransactionLinkResult',
  receiptFailureAction: 'receiptFailureAction',
  receiptDelete: 'receiptDelete',
  receiptAction: 'receiptAction',
  receiptActionResult: 'receiptActionResult',
  receiptCreateSplits: 'receiptCreateSplits',
  receiptDetailsView: 'receiptDetailsView',
  receiptSuggestionView: 'receiptSuggestionView',
  receiptDetach: 'receiptDetach',
  receiptFeedbackPositive: 'receiptFeedbackPositive',
  receiptFeedbackNegative: 'receiptFeedbackNegative',
  transactionDetailFeedbackPositive: 'transactionDetailFeedbackPositive',
  transactionDetailFeedbackNegative: 'transactionDetailFeedbackNegative',

  // BillScout post-GSF bulk setup (billsNewSetupExperiment)
  setupSeriesStart: 'setupSeriesStart', // { access: 'dashCard' | 'recurringEmpty' }
  setupSeriesOverview: 'setupSeriesOverview',
  setupSeriesIncome: 'setupSeriesIncome',
  setupSeriesIncomeSelect: 'setupSeriesIncomeSelect',
  setupSeriesincomeReview: 'setupSeriesincomeReview',
  setupSeriesIncomeBack: 'setupSeriesIncomeBack',
  setupSeriesBills: 'setupSeriesBills',
  setupSeriesBillsSelect: 'setupSeriesBillsSelect',
  setupSeriesBillsReview: 'setupSeriesBillsReview',
  setupSeriesBillsBack: 'setupSeriesBillsBack',
  setupSeriesSucess: 'setupSeriesSucess',
  setupSeriesComplete: 'setupSeriesComplete', // { 'next step': 'reminder' | 'cashflow' | 'spending plan' | 'close' }
  setupSeriesClose: 'setupSeriesClose',
  setupSeriesSaveExit: 'setupSeriesSaveExit', // { access: 'close' | 'button' }
  setupSeriesHideDetails: 'setupSeriesHideDetails', // { toggle: 'on' | 'off' }
};

export default events;
